import React from 'react';
import "../general/General.css";
import PropTypes from 'prop-types';

const Location = ({ windowWidth }) => {
    return (
        <div className="general_parent">
            <div className="general_container">
                <div className="general_body">
                    <h1>
                        இருப்பிட வரைபடங்கள்
                    </h1>
                    {windowWidth > 430 ? (
                        <>
                            <p><b>ஸ்ரீ பெரிய பொன்னாச்சி அம்மன் கோவில்:</b></p>
                            <div style={{ width: '100%', height: '500px'}}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.9123580638693!2d77.90637927496148!3d11.045197589120392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9808c4e425271%3A0x80e1e98090eccdb4!2sSri%20Periya%20Ponnachi%20Amman%20Temple!5e0!3m2!1sen!2sin!4v1728547861985!5m2!1sen!2sin&hl=ta"
                                    width="600"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    allow="fullscreen"
                                    loading="lazy"
                                    title='ஸ்ரீ பெரிய பொன்னாச்சி அம்மன் கோவில்'
                                ></iframe>
                            </div>
                            <br /><p><b>ஸ்ரீ சின்ன பொன்னாச்சி அம்மன் கோவில்:</b></p>
                            <div style={{ width: '100%', height: '500px' }}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.122382685229!2d77.8949699749612!3d11.029443689135107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba980c26865ae8f%3A0xacc75821e2efbd8a!2sSri%20Chinna%20Ponnachi%20Amman%20Temple!5e0!3m2!1sen!2sin!4v1728547251841!5m2!1sen!2sin&hl=ta"
                                    width="600"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    allow="fullscreen"
                                    loading="lazy"
                                    title='ஸ்ரீ சின்ன பொன்னாச்சி அம்மன் கோவில்'
                                ></iframe>
                            </div>
                        </>
                    ) : (
                        <>
                            <p><b>ஸ்ரீ பெரிய பொன்னாச்சி அம்மன் கோவில்:</b></p>
                            <div style={{ width: '300px', height: '225px', zoom: 0.80  }}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.9123580638693!2d77.90637927496148!3d11.045197589120392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9808c4e425271%3A0x80e1e98090eccdb4!2sSri%20Periya%20Ponnachi%20Amman%20Temple!5e0!3m2!1sen!2sin!4v1728547861985!5m2!1sen!2sin&hl=ta"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    allow="fullscreen"
                                    loading="lazy"
                                    title='ஸ்ரீ பெரிய பொன்னாச்சி அம்மன் கோவில்'
                                ></iframe>
                            </div>
                            <br />
                            <p><b>ஸ்ரீ சின்ன பொன்னாச்சி அம்மன் கோவில்:</b></p>
                            <div style={{ width: '300px', height: '225px', zoom: 0.80 }}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.122382685229!2d77.8949699749612!3d11.029443689135107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba980c26865ae8f%3A0xacc75821e2efbd8a!2sSri%20Chinna%20Ponnachi%20Amman%20Temple!5e0!3m2!1sen!2sin!4v1728547251841!5m2!1sen!2sin&hl=ta"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    allow="fullscreen"
                                    loading="lazy"
                                    title='ஸ்ரீ சின்ன பொன்னாச்சி அம்மன் கோவில்'
                                ></iframe>

                            </div>

                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
// PropTypes validation for windowWidth
Location.propTypes = {
    windowWidth: PropTypes.number.isRequired,  // Ensure windowWidth is a number and required
};

export default Location;
